import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import { ConfigService } from '../config/config-service';
import { SessionService } from './session.service';
import { environment } from '../../environments/environment.prod';

@Injectable()
export class ProductoService {
	private config: ConfigService;
	private _token: any;
	private host_api: String;
	private dbname: string;
	public uploadfile_api: String;

	constructor(
		private http: Http,
		private ss: SessionService,
	) {
		this.config = new ConfigService();
		this.host_api = this.ss.getData('host_api');
		this._token = sessionStorage.getItem('api-token');
		this.dbname = this.ss.getData('dbname');
		this.uploadfile_api = environment.uploadfile_api;
	}

	getAll(queryString: String = "") {
		let url = this.host_api + '/productos' + queryString;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res: Response) => {
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});
	}

	getByFilter(queryString: String = "") {
		let url = this.host_api + '/productos/getAll' + queryString;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res: Response) => {
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});
	}


	getPreciosByFilter(queryString: String = "") {
		let url = this.host_api + '/productos/getPrecios' + queryString;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res: Response) => {
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});
	}

	getById(id,  qs: String = "") {
		let url = this.host_api + '/productos/' + id + qs;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res: Response) => {
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});
	}

	getByCodigo(codigo) {
		let url = this.host_api + '/productos/search/' + codigo;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res: Response) => {
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});
	}

	getProductoEspecifico(queryString: String = "") {
		let url = this.host_api + '/productos/productoespecifico' + queryString;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	getWithPrice(id: String = "", qs = "") {
		let url = this.host_api + '/productos/all/' + id + qs;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res: Response) => {
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});
	}

	getServiciosWithPrice(qs = "") {
		let url = this.host_api + '/productos/servicios'+ qs;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res: Response) => {
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});
	}

	getTopVendidos(qs = "") {
		let url = this.host_api + '/productos/topvendidos' + qs;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res: Response) => {
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});
	}

	save(producto) {
		let url = this.host_api + '/productos';
		let params = producto;//JSON.stringify(categoria);
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);

		let options = new RequestOptions({ headers: headers });

		return this.http.post(url, params, options).map((res: Response) => {
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});
	}

	switchVerEcommerce(producto){
		let url = this.host_api + `/productos/${ producto.id }/verecommerce`;
		let params = producto;
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);

		let options = new RequestOptions({ headers: headers });

		return this.http.put(url, params, options).map((res: Response) => {
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});
	}

	uploadImage(image) {
		let url = this.uploadfile_api + '/upload/image';
		let params = image;
		let headers = new Headers();
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);

		let options = new RequestOptions({ headers: headers });

		return this.http.post(url, params, options).map((res: Response) => {
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});
	}

	update(producto) {
		let url = this.host_api + '/productos/' + producto.id;
		let params = JSON.stringify(producto);
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);

		let options = new RequestOptions({ headers: headers });

		return this.http.put(url, params, options).map((res: Response) => {
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});
	}

	delete(id) {
		var url = this.host_api + '/productos/' + id + '/del';
		let params = {usuario_id: this.ss.getData('usuario_id')};
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.put(url, params, options).map((res:Response) => {
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});
	}

	activar(id) {
		var url = this.host_api + '/productos/' + id + '/activar';
		let params = {usuario_id: this.ss.getData('usuario_id')};
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.put(url, params, options).map((res:Response) => {
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});
	}

	PrecioCosto(producto){
		let url = this.host_api + '/productos/precios';
		let params = producto;
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);

		let options = new RequestOptions({ headers: headers });

		return this.http.post(url, params, options).map((res: Response) => {
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});
	}

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/services/producto.service.ts